import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours-page01',
  templateUrl: './tours-page01.component.html',
  styleUrls: ['./tours-page01.component.css']
})
export class ToursPage01Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
